import React, { useEffect, useRef, useState } from "react";
import styles from '../styles/list.module.scss'
import { wait } from "@/commonHooks/nextTick";
import { useVenueBalanceList } from "@/api/request";
import Switch from "@/wmCompoments/switch";
import { useTranslation } from "react-i18next";

const List = () => {
    const { t } = useTranslation('transferCenter')
    
    const [checked, setChecked] = useState(false)
    const { allBalance, hasBalance } = useVenueBalanceList()


    const contentRef = useRef<HTMLDivElement>(null)
    const [, setRefresh] = React.useState({})
    const balanceList = checked ? hasBalance : allBalance

    useEffect(() => {
        wait(16).then(() => {
            setRefresh({})
        })
    }, [balanceList])

    return <div className={styles.warpper}>
        <div>
            <span>{t('walletDetails')}</span>
            <div className={styles.switchWarpper}>
                <span>{t('hideZeroBalanceVenues')}</span>
                <Switch onChange={(v) => {
                    setChecked(v)
                }} checked={checked} className={styles.switch} />
            </div>
        </div>

        <div
            style={{
                height: (Number(contentRef.current?.getBoundingClientRect().height) + (balanceList?.length ? 10 : 0)) + 'px'
            }} className={styles.listWarpper}>
            <div className={styles.venueList}
                ref={contentRef}
            >
                {
                    balanceList?.map((v) => {
                        return <div key={v.id?.toString()+v.amount?.toString()} className={styles.venueItem}>
                            <span>{v.zhName}</span>
                            <span>{ut.formatToFixedTwo(v.money)}</span>
                        </div>
                    })
                }
            </div>
        </div>


    </div>

}

export default List